"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconNavigatorHeaderWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var FalconNavigatorHeaderWidget = /** @class */ (function (_super) {
    __extends(FalconNavigatorHeaderWidget, _super);
    function FalconNavigatorHeaderWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FalconNavigatorHeaderWidget.prototype.render = function () {
        var title = this.getSetting("title");
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: title && (0, jsx_runtime_1.jsx)(portal_core_1.FalconNavigatorHeader, { title: { label: this.renderHtml(title) } }) });
    };
    FalconNavigatorHeaderWidget.prototype.renderInputField = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    return FalconNavigatorHeaderWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.FalconNavigatorHeaderWidget = FalconNavigatorHeaderWidget;
//# sourceMappingURL=FalconNavigatorHeaderWidget.js.map